<template>
  <div>
    <h2>{{confirmation.heading}}</h2>

    <v-container v-if="!busy && confirmation" class="confirm-container">
      <v-row class="justify-content-center">
        <v-col cols="12" class="confirm-heading">
          {{confirmation.subHeading}}
        </v-col>
        <v-col cols="12" md="6">
          <v-btn color="primary" @click="refresh()" v-if="confirmation && !confirmation.successful">Refresh</v-btn>
        </v-col>
      </v-row>
      <v-row v-for="msg in confirmation.details" :key="msg.order">
        <v-col cols="12">
          <div v-html="msg.detail"></div>
        </v-col>
      </v-row>
    </v-container>


    <v-btn color="primary" block class="mb-2" @click="goHome()">
      Home
    </v-btn>

  </div>
</template>

<script>
import router from "../router";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapMissedDeliveryGetters } = createNamespacedHelpers(
  "missedDelivery"
);

export default {
  name: "Confirmation",
  data: () => ({}),
  computed: {
    ...mapMissedDeliveryGetters(["confirmation", "busy", "routePaths"]),
  },
  methods: {
    goHome: function () {
      router.push(this.routePaths.MissedDelivery);
    },
    refresh: function () {
      const ref = this.$route.query.ref;
      this.$store.dispatch("missedDelivery/getConfirmation", ref);
    }
  },
  mounted() {
    const ref = this.$route.query.ref;
    this.$store.dispatch("missedDelivery/getConfirmation", ref);
  },
};
</script>

<style scoped>
.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}

.confirm-container {
  margin-left: 0px;
}

.confirm-heading {
  padding-top: 15px;
  margin-right: -60px;
}
</style>
